export const NAME = 'agentReviewSummary'

export const ORDER_COMPLIMENTS = [
  // required order to handle for front end
  'Market Expertise',
  'Local Area Knowledge',
  'Communication Skills',
  'Attention To Detail',
]
